import { Button, Card, Col, Form, Input, Row, Select } from "antd";
import TextArea from "antd/es/input/TextArea";

import React, { useEffect, useState } from "react";

import { RiCloseCircleLine, RiAddCircleFill } from "react-icons/ri";
import { v4 as uuidv4 } from "uuid";
import { db } from "../../../../../../firebase";
import { collection, getDocs } from "firebase/firestore";
import { useSelector } from "react-redux";
import { SelectUser } from "../../../../../../store/usersSlice";

function RecurringDetails({ edit, data, accounts, setAccounts }) {
  const [properties, setProperties] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [users, setUsers] = useState([]);

  const userData = useSelector(SelectUser);

  useEffect(() => {
    if (userData.companyName) {
      const fetchProperties = async () => {
        try {
          const propertyRef = collection(
            db,
            "companies",
            userData.companyName,
            "properties"
          );
          const vendorRef = collection(
            db,
            "companies",
            userData.companyName,
            "vendors"
          );
          const userRef = collection(
            db,
            "companies",
            userData.companyName,
            "users"
          );
          const snapshot = await getDocs(propertyRef);
          const snapData = await getDocs(vendorRef);
          const userSnapData = await getDocs(userRef);

          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            value: doc.id,
            label: doc.data().propertyNameAddress.propertyName,
            ...doc.data(),
          }));

          const fetchedVenData = snapData.docs.map((doc) => ({
            id: doc.id,
            value: doc.id,
            label:
              doc.data().vendorInfo.firstName +
              " " +
              doc.data().vendorInfo.lastName,
            ...doc.data(),
          }));

          const fetchedVUserData = userSnapData.docs.map((doc) => ({
            id: doc.id,
            value: doc.id,
            label:
              doc.data().profile.firstName + " " + doc.data().profile.lastName,
            ...doc.data(),
          }));

          console.log("propertuies", fetchedData);

          setProperties(fetchedData);
          setVendors(fetchedVenData);
          setUsers(fetchedVUserData);
          console.log(data);
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchProperties();
    }
  }, []);

  const addAccount = () => {
    const newAccount = {
      id: uuidv4(),
      account: "",
      descriptions: "",
      amount: "",
    };
    setAccounts((prevAccounts) => [...prevAccounts, newAccount]);
  };

  const removeAccount = (id) => {
    const updatedAccounts = accounts.filter((item) => {
      return item.id !== id;
    });
    setAccounts(updatedAccounts);
  };

  const handleChange = (value, name, id) => {
    const updatedAccounts = accounts.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setAccounts(updatedAccounts);
  };

  const accountType = [
    { value: "Insurance Service" },
    { value: "Lease Break Fee" },
    { value: "Integrity Lease Break Fee" },
    { value: "Lease Prep Fee" },
  ];

  let totalAmount = 0;
  for (let i = 0; i < data?.details?.billingInfo.length; i++) {
    totalAmount = totalAmount + Number(data?.details?.billingInfo[i].amount);
  }

  return (
    <Card title="Details">
      {!edit ? (
        <Form colon={false} labelCol={{ span: 8 }} wrapperCol={{ span: 8 }}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <Row gutter={[0, 4]}>
                <Col span={24}>
                  <strong>Property Information</strong>
                </Col>
                <Col span={24}>
                  <Form.Item label="Properties">
                    <p className="onclick-text">
                      {data?.property ? data?.property : "--"}
                    </p>
                  </Form.Item>
                  <Form.Item label="Maintenance Limit">
                    <p>
                      {data?.maintenanceLimit ? data?.maintenanceLimit : "--"}
                    </p>
                  </Form.Item>
                  <Form.Item label="Unit">
                    <p>
                      {data?.details?.propertyInfo?.unit
                        ? data?.details?.propertyInfo?.unit
                        : "--"}
                    </p>
                  </Form.Item>
                  <Form.Item label="Maintenance Notes">
                    <p>
                      {data?.maintenanceNotes ? data?.maintenanceNotes : "--"}
                    </p>
                  </Form.Item>
                  <Form.Item label="Creation Style">
                    <p>
                      {data?.details?.propertyInfo
                        ? data?.details?.propertyInfo?.creationStyle
                        : "--"}
                    </p>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={[0, 4]}>
                <Col span={24}>
                  <strong>Work Order Information</strong>
                </Col>
                <Col span={24}>
                  <Form.Item label="Description">
                    <p>
                      {data?.details?.workOrderInfo
                        ? data?.details?.workOrderInfo?.description
                        : "--"}
                    </p>
                  </Form.Item>
                  <Form.Item label="Vendor Instructions">
                    <p>
                      {data?.details?.workOrderInfo
                        ? data?.details?.workOrderInfo?.vendorInstructions
                        : "--"}
                    </p>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={[0, 4]}>
                <Col span={24}>
                  <strong>Vendor Information</strong>
                </Col>
                <Col span={24}>
                  <Form.Item label="Vendor">
                    <p>{data?.vendor ? data?.vendor : "--"}</p>
                  </Form.Item>
                  <Form.Item label="Assign To">
                    <p>
                      {data?.details?.vendorInfo?.assignTo
                        ? data.details?.vendorInfo?.assignTo
                        : "--"}
                    </p>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={[0, 16]}>
                <Col span={24}>
                  <strong>Billing Information</strong>
                </Col>
                <Col span={24}>
                  <Row gutter={[0, 8]}>
                    <Col span={24}>
                      <Row className="header-row">
                        <Col span={6}>
                          <span>Account</span>
                        </Col>
                        <Col span={12}>
                          <span>Statement Description</span>
                        </Col>
                        <Col span={6}>
                          <span>Amount</span>
                        </Col>
                      </Row>
                      {data?.details?.billingInfo
                        ? data.details?.billingInfo.map((item, index) => {
                            return (
                              <Row className="data-row" key={index}>
                                <Col span={6}>
                                  <span>{item.account}</span>
                                </Col>
                                <Col span={12}>
                                  <span>{item.statementDescription}</span>
                                </Col>
                                <Col span={6}>
                                  <span>{item.amount}</span>
                                </Col>
                              </Row>
                            );
                          })
                        : null}
                    </Col>
                    <Col span={24}>
                      <Row gutter={[200, 0]} justify="end">
                        <Col>
                          <strong>Total:</strong>
                        </Col>
                        <Col>
                          <strong>{totalAmount}</strong>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      ) : (
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <Row gutter={[0, 4]}>
              <Col span={24}>
                <strong>Property Information</strong>
              </Col>
              <Col span={24}>
                <Form.Item label="Properties" required name="properties">
                  <Select
                    options={properties}
                    showSearch
                    allowClear
                    placeholder="Type to search"
                  />
                </Form.Item>
                <Form.Item label="Unit" name="unit">
                  <Select options={properties} />
                </Form.Item>
                <Form.Item label="Creation Style" name="creationStyle">
                  <Select
                    options={[{ value: "Per Property" }, { value: "Per Unit" }]}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 4]}>
              <Col span={24}>
                <strong>Work Order Information</strong>
              </Col>
              <Col span={24}>
                <Form.Item label="Description" name="description">
                  <TextArea rows={3} />
                </Form.Item>
                <Form.Item
                  label="Vendor Instructions"
                  name="vendorInstructions"
                >
                  <TextArea rows={3} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 4]}>
              <Col span={24}>
                <strong>Vendor Information</strong>
              </Col>
              <Col span={24}>
                <Form.Item label="Vendor" name="vendor">
                  <Select
                    showSearch
                    allowClear
                    options={vendors}
                    placeholder="Type to search"
                  />
                </Form.Item>
                <Form.Item label="Assign To" name="assignTo">
                  <Select
                    showSearch
                    allowClear
                    options={users}
                    placeholder="Type to search"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <strong>Billing Information</strong>
              </Col>
              <Col span={24}>
                <Row gutter={[0, 8]}>
                  <Col span={24} className="row-container">
                    <Row>
                      <Col span={6} className="header-row">
                        <span>Account</span>
                      </Col>
                      <Col span={11} className="header-row">
                        <span>Statement Description</span>
                      </Col>
                      <Col span={6} className="header-row">
                        <span>Amount</span>
                      </Col>
                    </Row>
                    {accounts.map((item) => {
                      return (
                        <Row key={item.id} gutter={[8, 0]} align="middle">
                          <Col span={6}>
                            <Select
                              options={accountType}
                              placeholder="Select..."
                              style={{ width: "100%" }}
                              value={item.account}
                              onChange={(value) =>
                                handleChange(value, "account", item.id)
                              }
                            />
                          </Col>
                          <Col span={11}>
                            <Input
                              placeholder="Statment description"
                              value={item.statementDescription}
                              onChange={(e) =>
                                handleChange(
                                  e.target.value,
                                  "statementDescription",
                                  item.id
                                )
                              }
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              type="Number"
                              prefix="$"
                              value={item.amount}
                              onChange={(e) =>
                                handleChange(e.target.value, "amount", item.id)
                              }
                            />
                          </Col>
                          <Col span={1}>
                            <RiCloseCircleLine
                              size={18}
                              onClick={() => removeAccount(item.id)}
                              className="icon-delete"
                            />
                          </Col>
                        </Row>
                      );
                    })}
                  </Col>
                  <Col span={24}>
                    <Button className="add-icon-btn" onClick={addAccount}>
                      <RiAddCircleFill size={18} />
                      <span>Add Another Line</span>
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Card>
  );
}

export default RecurringDetails;
